export default "__VITE_ASSET__DDS06ZMJ__"